export default __webpack_public_path__ + "static/media/lock.86f70720.svg";